import api from './api'
import queryString from 'querystring'

const soleProprietorshipBasePath = '/api/v1/sole-proprietorship'

export async function getSoleProprietorship(getQueryParams) {
  const resp = await api.get(`${soleProprietorshipBasePath}?${queryString.stringify(getQueryParams)}`)
  return resp.data
}

export async function searchSoleProprietorship(searchQueryParams) {
  const resp = await api.get(`${soleProprietorshipBasePath}/search?${queryString.stringify(searchQueryParams)}`)
  return resp.data
}

//TODO kell ez a ccorporation letrehozasanal???
export async function getSoleProprietorshipFieldFormTemplates() {
  const resp = await api.get(`${soleProprietorshipBasePath}/company-form-fields`)
  return resp.data
}
